export default {
    API_URL: process.env.VUE_APP_API_URL,
    HEADERS: {'Authorization': 'Bearer zfWWWLnZPc4icEKhZo19utQFMz36QOyHqPp1uFNn2LpIau1LJ80bKuJgFGIKDqSS'}
}